import { render, staticRenderFns } from "./BasicClientInformationPopUp.vue?vue&type=template&id=95ab1358&"
import script from "./BasicClientInformationPopUp.vue?vue&type=script&lang=js&"
export * from "./BasicClientInformationPopUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports